import React from 'react';
import { T } from '../../../helpers/i18n';
import { Texto } from '../Texto';
export var BlockUser = function (_a) {
    var user = _a.user, collaboratorName = _a.collaboratorName, align = _a.align, fontSize = _a.fontSize, bold = _a.bold;
    return (React.createElement("div", { style: { width: '100%', textAlign: align } },
        !collaboratorName &&
            React.createElement(Texto, { texto: "".concat(T('sellBy'), " ").concat(user), align: align, fontSize: fontSize, bold: bold }),
        collaboratorName &&
            React.createElement(Texto, { texto: "".concat(T('sellBy'), " ").concat(collaboratorName, " - ").concat(user), align: align, fontSize: fontSize, bold: bold })));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockUser.tsx
// module id = 258
// module chunks = 0